import { Outlet } from 'react-router';
import { QueryProvider } from '../providers/QueryProvider';
import { ToastProvider } from '../providers/ToastProvider';

export function AppShell() {
  return (
    <QueryProvider>
      <ToastProvider />
      <Outlet />
    </QueryProvider>
  );
}
